import CatalogLink from './CatalogLink';

const CATALOG_TITLE_LINK = 'catalogtitlelink';
const CATALOG_AUTHOR_LINK = 'catalogauthorlink';
const REL_KEY = 'rel';

/**
 * Gets the catalog link for a specific title.
 * @param {Object[]} links An array of all links associated to the specific title.
 * @returns {string} The URL to the author's detail page in the current catalog.
 */
export function getTitleCatalogLink(links) {
	let titleCatalogUrl = getCatalogUrlByType(CATALOG_TITLE_LINK, links);

	return titleCatalogUrl;
}

/**
 * Gets the catalog link for a specific author.
 * @param {Object[]} links An array of all links associated to the specific author.
 * @returns {string} The URL to the author's detail page in the current catalog.
 */
export function getAuthorCatalogLink(links) {
	let authorCatalogUrl = getCatalogUrlByType(CATALOG_AUTHOR_LINK, links);

	return authorCatalogUrl;
}

/**
 * Attempts to find the Catalog URL from the provided array of links by checking to see if any of the
 * provided link objects contains a "rel" key whose value is equal to the unique type provided by the server.
 * @param {string} type The type of catalog link to find.
 * @param {Object[]} links An array of all links associated to the specified type.
 * @returns {CatalogLink} Either the found URL or an empty string.
 */
function getCatalogUrlByType(type, links) {
	if (!links) { return ''; }

	let catalogUrl;

	const relValue = `http://novselect.ebscohost.com/rels#${type}`;

	for (let index = 0; index < links.length; index++) {
		if (links[index].hasOwnProperty(REL_KEY) && links[index][REL_KEY] === relValue) {
			let url = (links[index].url) ? links[index].url : '';
			let target = (links[index].target) ? links[index].target : '';

			catalogUrl = new CatalogLink(url, target);

			break;
		}
	}

	return catalogUrl;
}



// WEBPACK FOOTER //
// ./src/lib/CatalogLinkUtilities.js